"use client"

import clsx from "clsx"
import React, { ReactNode } from "react"

export interface FormFieldBaseProps {
  errorMessage?: string | null
  isValid?: boolean
  touched?: boolean
  blurred?: boolean
  className?: string
  children: ReactNode
  hasValue?: boolean
}

const FormFieldBase: React.FC<FormFieldBaseProps> = ({
  errorMessage,
  isValid = false,
  touched = false,
  blurred = false,
  className,
  children,
  hasValue = false,
}) => {
  const showError = !isValid && touched && blurred && errorMessage?.trim()
  const showSuccess = isValid && hasValue

  return (
    <div className={clsx("relative w-full font-nunito", showError ? "mb-1" : "mb-6", className)}>
      <div
        className={clsx("relative w-full rounded-lg border-2 px-4 py-2 transition-colors", {
          "border-[#C20000] bg-[#FFF5F5]": showError,
          "border-blue-500 bg-blue-50": showSuccess && !showError,
          "border-gray-300 bg-white": (!showError && !showSuccess) || !hasValue,
        })}
      >
        <div className="relative w-full">{children}</div>
      </div>

      {showError && <p className="mb-0 mt-1 font-nunito text-xs text-[#C20000]">{errorMessage}</p>}
    </div>
  )
}

export default FormFieldBase
